import React from "react";
import { Table } from "antd";
import "../styles/NestedTable.css";
import numberFormat from "../utils/numberFormat";

const NestedHoldingsTable = ({
  data,
  loading,
  baseColumns,
  nestedColumns,
  rowKey = "stockName",
}) => {
  const expandable = {
    expandedRowRender: (record) => (
      <Table
        columns={nestedColumns}
        dataSource={record.funds.map((fund) => ({
          ...fund,
          key: `${record.stockName}-${fund.mutualFundId}`,
        }))}
        pagination={false}
        size="small"
      />
    ),
    rowExpandable: (record) => record.funds && record.funds.length > 0,
  };

  return (
    <Table
      className="insights-table"
      rowKey={rowKey}
      columns={baseColumns}
      dataSource={data}
      loading={loading}
      expandable={expandable}
      pagination={false}
      bordered
      size="middle"
      scroll={{ x: true }}
    />
  );
};

export default NestedHoldingsTable;